<template>
  <el-form
    ref="pwdForm"
    :model="form"
    :rules="rules"
    label-width="120px"
    class="change-pwd-form"
  >
    <el-form-item label="原密码" prop="oldPwd">
      <el-input
        v-model="form.oldPwd"
        type="password"
        placeholder="请输入原密码"
      />
    </el-form-item>
    <el-form-item label="新密码" prop="newPwd">
      <el-input
        v-model="form.newPwd"
        type="password"
        placeholder="请输入新密码"
      />
    </el-form-item>
    <el-form-item label="确认新密码" prop="confirmPwd">
      <el-input
        v-model="form.confirmPwd"
        type="password"
        placeholder="请再次输入新密码"
      />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitForm">确认修改</el-button>
      <el-button @click="resetForm">重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { ElMessage } from 'element-plus';
import axios from 'axios';

// 表单数据
const form = reactive({
  oldPwd: '',
  newPwd: '',
  confirmPwd: ''
});

// 表单验证规则
const rules = {
  oldPwd: [
    { required: true, message: '请输入原密码', trigger: 'blur' }
  ],
  newPwd: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
  ],
  confirmPwd: [
    { required: true, message: '请确认新密码', trigger: 'blur' },
    { 
      validator: (rule, value, callback) => {
        if (value !== form.newPwd) {
          callback(new Error('两次输入的密码不一致'));
        } else {
          callback();
        }
      },
      trigger: 'blur'
    }
  ]
};

const pwdForm = ref(null);

// 提交表单
const submitForm = async () => {
  try {
    await pwdForm.value.validate();
    // 调用后端接口
    const res = await axios.post('/api/change-pwd', form, {
      withCredentials: true  // 携带Cookie（Session依赖）
    });
    if (res.data.code === 200) {
      ElMessage.success(res.data.msg);
      resetForm();
    } else {
      ElMessage.error(res.data.msg);
    }
  } catch (error) {
    ElMessage.error('操作失败，请重试');
  }
};

// 重置表单
const resetForm = () => {
  pwdForm.value.resetFields();
};
</script>

<style scoped>
.change-pwd-form {
  max-width: 500px;
  margin: 50px auto;
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
}
</style>